module.exports = __webpack_public_path__ + "assets/351f0c3d8c217d35b6f934b2d980bfe9.mp3";